// extracted by mini-css-extract-plugin
export var button = "PetSpeciesSelector-module--button--e97bd";
export var form = "PetSpeciesSelector-module--form--f24e1";
export var hasTransition = "PetSpeciesSelector-module--hasTransition--af384";
export var petSpeciesSelector = "PetSpeciesSelector-module--petSpeciesSelector--3a92c";
export var sectionTitle = "PetSpeciesSelector-module--sectionTitle--8ce41";
export var speciesSelected = "PetSpeciesSelector-module--speciesSelected--613d8";